<div class="dalog-header">
  <h2>Comments</h2>
  <button
    type="button"
    class="btn-cust-close"
    (click)="navService.openSideNav({ toogle: true })"
  >
    <i class="icon-close"></i>
  </button>
</div>
<div
  #scrollContainer
  class="side-drawer-content pb-5"
  infiniteScroll
  [infiniteScrollUpDistance]="1.5"
  [infiniteScrollThrottle]="20"
  [scrollWindow]="false"
  (scrolledUp)="onScroll()"
>
  @if (isLoading) {
  @for (item of [1,2,3,4]; track $index) {
  <div class="activitycard">
    <div class="activitycard_user">
      <ngx-skeleton-loader
        [theme]="{ width: '35px', height: '33px', 'border-radius': '50%', margin: 0 }"
      />
    </div>
    <div class="activitycard_text">
      <ngx-skeleton-loader
        style="display: block"
        [theme]="{ width: '90px', height: '10px', margin: 0 }"
      />
      <ngx-skeleton-loader
        style="display: block"
        [theme]="{ width: '130px', height: '14px', margin: '4px 0 0 0' }"
      />
      <ngx-skeleton-loader
        style="display: block"
        [theme]="{ width: '85%', height: '12px', margin: '4px 0 0 0' }"
      />
    </div>
  </div>
  }
  } @else { @for (item of log_list; track $index) {

  <div class="activitycard" [id]="item?.id">
    <div class="activitycard_user">
      @if (item?.profilePhoto && !imgErrorIds.has(item?.id)) {
      <img
        [src]="Global.BACKEND_URL + '/users/' + item?.profilePhoto"
        class="profile-image"
        alt=""
        (error)="onImageError(item?.id)"
      />
      } @else {
      {{ item?.actionByName.charAt(0) }}
      }
    </div>
    <div class="activitycard_text">
      <span>{{
        Global.formatDateToUTC(item?.actionDate) | date : "medium"
      }}</span>
      <h5>
        {{ item?.actionByName }}
      </h5>
      <p>
        {{ item?.remarks }}
        <ng-container *ngIf="item?.imageUrl">
          @if (Global.isImage(item?.imageUrl)) {
          <img
            (click)="viewAttachment(item)"
            [src]="Global.BACKEND_URL + '/TrackingDocument/' + item?.imageUrl"
            alt=""
            class="img-fluid"
          />
          } @else {
          <a
            [href]="Global.BACKEND_URL + '/TrackingDocument/' + item?.imageUrl"
            target="_blank"
            >attachment</a
          >
          }
        </ng-container>
      </p>
    </div>
  </div>
  } @empty {
  <div class="empty-comments-wrap">
    <img src="assets/images/comments-empty-stage.svg" />
    <p>No comments found</p>
  </div>
  } }
</div>

<div [formGroup]="formGroup" class="remarks-cards">
  <div class="chat-composer">
    <button class="chat-icon-btn" type="button" title="Attach file">
      <i
        class="fa fa-paperclip"
        aria-hidden="true"
        matBadge="1"
        matBadgeColor="warn"
        [matBadgeHidden]="!formGroup.value.imageUrlData"
      ></i>
      <input
        type="file"
        accept=".pdf, .xls, .xlsx,.png, .jpeg"
        (change)="
          Global.onFileUploadedToBase64(
            formGroup,
            $event,
            'imageUrlData',
            toastr,
            [
              'application/pdf',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'image/jpeg',
              'image/png'
            ],
            'fileName',
            [
              'application/pdf',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'image/jpeg',
              'image/png'
            ]
          )
        "
        class="custom-file-input"
        id="customFile"
      />
    </button>
    <input
      formControlName="remarks"
      type="text"
      class="chat-input"
      placeholder="Type a message"
      (keydown.enter)="onRemarkAdd()"
    />
    <button
      (click)="onRemarkAdd()"
      class="chat-send-btn"
      type="button"
      [disabled]="!formGroup.value.remarks?.trim()"
      title="Send"
    >
      <i class="fa fa-paper-plane" aria-hidden="true"></i>
    </button>
  </div>
</div>
<!-- </mat-tab> -->
<!-- </mat-tab-group> -->
